import { render, staticRenderFns } from "./RegisterVolunteerView.vue?vue&type=template&id=8b138dc4&"
import script from "./RegisterVolunteerView.vue?vue&type=script&lang=js&"
export * from "./RegisterVolunteerView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVolunteerView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperContent } from 'vuetify/lib'
import { VStepperHeader } from 'vuetify/lib'
import { VStepperItems } from 'vuetify/lib'
import { VStepperStep } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider,VFooter,VSpacer,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
